import React,{useState} from 'react';
import { connect } from 'react-redux';

import {useStripe, useElements} from '@stripe/react-stripe-js';
import {ExpressCheckoutElement} from '@stripe/react-stripe-js';
import actions from '../../../../../store/actions';
const { customer: customerActions } = actions;

const StripeGooglePay = (props) => {

  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(false);

  const {
    payFormSelected
    , validForm
    , confirmBookingOnlyStore
    , temporaryBookingOnlyStore
    , reservation
    , stripeOptions
  } = props;

  const hotelId = props.hotelId;
  const tracking = props.tracking;
  const hotelCode = props.hotelCode;

  const onConfirm = async (event) => {

    if (!stripe && !elements)
      return false;

    if (validForm) {

      try{
        const domain = process.env.URLTPV_ENVIROMENT;
        const urlOK = domain + '/api/hotels/'+hotelId+'/cms/redirect_3d_secure/'+hotelCode+'-'+tracking;

        if(!stripeOptions.clientSecret)
          return false;

        confirmBookingOnlyStore({reservation});
        const {error} = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url: urlOK,
          }
        })

        if (error){

          temporaryBookingOnlyStore({reservation})

          setErrorMessage('Error al procesar...!!!');
          return false;
        }
      }catch (e) {

        console.log('Error al procesar con stripe', e);

        temporaryBookingOnlyStore({reservation})
      }
    }
  }

  if(payFormSelected !== 'googlePay')
    return false;

  return (
    <div
      id={'stripeIframe'}
      style={{
        width: '100%',
        maxWidth: '400px'
      }}
    >
      {validForm ?
      <ExpressCheckoutElement
        onConfirm={onConfirm}
        options={{
          paymentMethods: {
            googlePay: 'always',
            applePay: 'never',
            link: 'never'
          },
          buttonType:{
            googlePay: 'buy'
          },
          buttonTheme:{
            googlePay: 'black'
          }
        }}
      /> : <div>
          <div
          style={{
            cursor: 'not-allowed',
            width: '215px',
            height: '45px',
            backgroundColor: '#000000',
            borderRadius: '4px',
            opacity: '0.6',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
          }}>
            <img
              src={'/assets/images/googlepay40.png'}
              style={{
                width: '215px',
                height: '45px',
                backgroundColor: '#000000',
                borderRadius: '5px',
              }}
              alt={'googlePay'}
            />
        </div>
        </div> }

      {errorMessage && <div>{errorMessage}</div>}
    </div>
  )
};

const mapDispatchToProps = (dispatch, ownProps, state) => {

  return {
    confirmBookingOnlyStore: ({reservation}) => {
      dispatch(customerActions.reservation.set(reservation.set('status', 'confirmed')));
    },
    temporaryBookingOnlyStore: ({reservation}) => {
      dispatch(customerActions.reservation.set(reservation.set('status', 'temporary')));
    }
  }
}

const mapStateToProps = (state) => {

  return {
    reservation: state.getIn(['customer', 'reservation']),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StripeGooglePay);